export default __webpack_public_path__ + "static/media/india.be08e68d.png";